import Dialog from '@comp/Dialog/Dialog';

const ImageSizeLimitDialog = ({
  maxAttachmentSizeInKB,
  dialogState,
  onCloseDialog,
  imgComp
}) => {
  const errorMessage = `Select a picture from your gallery that is smaller than ${Math.floor(
    maxAttachmentSizeInKB / 1000
  )} MB`;
  return (
    <Dialog
      onClose={onCloseDialog}
      dialogState={dialogState}
      heading="Picture is too large"
      message={errorMessage}
      acceptLabel="Got it"
      acceptOnClick={onCloseDialog}
      acceptLabelVariant="filled"
      acceptLabelTheme="black"
      styledStringMsgWrapper=""
      aboveHeading={imgComp}
      messageColor="var(--color-text-secondary)"
    />
  );
};

export default ImageSizeLimitDialog;
